var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attachment"},[_c('a',{attrs:{"href":decodeURI(_vm.attachment.url),"target":"_blank"}},[_vm._v(_vm._s(_vm.attachment.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }